import { THERAPIST } from "@/data/catalog";
import { Phone, Mail, MapPin } from "lucide-react";
import { useT } from "@/i18n/I18nProvider";

export default function AboutContact() {
    const { t } = useT();
    return (
        <section
            id="contact"
            data-testid="about-contact-section"
            className="py-20 md:py-32 scroll-mt-24"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                <div className="relative">
                    <img
                        src="https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxtYXNzYWdlJTIwdGhlcmFweSUyMHJlbGF4fGVufDB8fHx8MTc4MTQwNzA0OXww&ixlib=rb-4.1.0&q=85"
                        alt="Cabinet"
                        className="rounded-[2rem] w-full aspect-[4/5] object-cover shadow-2xl"
                        data-testid="about-image"
                    />
                    <div className="absolute -bottom-6 -right-6 bg-[#C44569] text-white rounded-2xl px-6 py-5 shadow-xl hidden sm:block">
                        <div className="text-xs uppercase tracking-[0.2em] opacity-80">
                            {t("about.cabinet_tag")}
                        </div>
                        <div className="font-display text-xl mt-1">Blainville</div>
                    </div>
                </div>

                <div>
                    <div className="text-xs tracking-[0.3em] uppercase text-[#3D8C95] mb-4">
                        {t("about.eyebrow")}
                    </div>
                    <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-light text-[#2C2A29] tracking-tight leading-tight">
                        Jérémy <span className="italic text-[#E07A5F]">Tessier</span>
                    </h2>
                    <p className="mt-6 text-[#6E6862] leading-relaxed text-base md:text-lg">
                        {t("about.desc")}
                    </p>

                    <div className="mt-10 space-y-5">
                        <a
                            href={`tel:${THERAPIST.phone}`}
                            data-testid="contact-phone-link"
                            className="flex items-start gap-4 group"
                        >
                            <div className="w-12 h-12 rounded-2xl bg-[#E07A5F]/10 flex items-center justify-center group-hover:bg-[#E07A5F] transition-colors">
                                <Phone size={20} className="text-[#E07A5F] group-hover:text-white transition-colors" />
                            </div>
                            <div>
                                <div className="text-xs uppercase tracking-[0.2em] text-[#6E6862]">
                                    {t("about.phone_label")}
                                </div>
                                <div className="font-display text-2xl text-[#2C2A29] group-hover:text-[#E07A5F] transition-colors">
                                    {THERAPIST.phone}
                                </div>
                            </div>
                        </a>

                        <a
                            href={`mailto:${THERAPIST.email}`}
                            data-testid="contact-email-link"
                            className="flex items-start gap-4 group"
                        >
                            <div className="w-12 h-12 rounded-2xl bg-[#3D8C95]/10 flex items-center justify-center group-hover:bg-[#3D8C95] transition-colors">
                                <Mail size={20} className="text-[#3D8C95] group-hover:text-white transition-colors" />
                            </div>
                            <div>
                                <div className="text-xs uppercase tracking-[0.2em] text-[#6E6862]">
                                    {t("about.email_label")}
                                </div>
                                <div className="font-display text-xl text-[#2C2A29] group-hover:text-[#3D8C95] transition-colors break-all">
                                    {THERAPIST.email}
                                </div>
                            </div>
                        </a>

                        <div className="flex items-start gap-4" data-testid="contact-address">
                            <div className="w-12 h-12 rounded-2xl bg-[#C44569]/10 flex items-center justify-center">
                                <MapPin size={20} className="text-[#C44569]" />
                            </div>
                            <div>
                                <div className="text-xs uppercase tracking-[0.2em] text-[#6E6862]">
                                    {t("about.address_label")}
                                </div>
                                <div className="font-display text-xl text-[#2C2A29]">
                                    {THERAPIST.address}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
